<template>
  <tr>
    <td class="text-xs-left">
      <v-checkbox
        v-model="props.selected"
        hide-details
      />
    </td>
    <td>{{ props.item.order }}</td>
    <td>{{ props.item.code }}</td>
    <td>
      <router-link
        :to="{
          name: 'single-taxonomy',
          params: { id: props.item.id }
        }"
        class="text-no-wrap"
      >
        {{ props.item.name }}
      </router-link>
    </td>
    <td>{{ props.item.products ? props.item.products.length : 0 }}</td>
    <td>{{ props.item.fullTaxonomy }}</td>
  </tr>
</template>
<script>
export default {
  name: 'TaxonomyDataTableRow',

  props: {
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
